import SVG from "../../../Components/SVG";
import Custom from "../../../Components/Buttons/Custom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MissionsGrid from "./MissionsGrid";
import MissionsTable from "./MissionsTable";

export default function Missions({ rulesData, accountData, ruleLoading }) {
  const navigate = useNavigate();
  const [targetStatus, setTargetStatus] = useState("stable");
  const [totalDrawdownStatus, setTotalDrawdownStatus] = useState("stable");
  const [dailyDrawdownStatus, setDailyDrawdownStatus] = useState("stable");
  const [tradeDrawdownStatus, setTradeDrawdownStatus] = useState("stable");
  const [minTradingDaysStatus, setMinTradingDaysStatus] = useState("stable");
  const [consRuleStatus, setConsRuleStatus] = useState("stable");
  const [scalpProfitStatus, setScalpProfitStatus] = useState("stable");
  const [activeFilter] = useState(() => {
    if (window.innerWidth >= 480) {
      return [false, true];
    }
    return [true, false];
  });

  useEffect(() => {
    console.log("Account Data in Missions:", rulesData);
    if (rulesData !== null && rulesData !== undefined) {
      // Example logic to determine target status based on rulesData
      if (rulesData.status === "live") {
        if (
          Number(rulesData.rules.profit_target.current_state) >=
          Number(rulesData.rules.profit_target.definition)
        ) {
          setTargetStatus("passed");
        } else if (
          Number(rulesData.rules.profit_target.current_state) <
            Number(rulesData.rules.profit_target.definition) &&
          Number(rulesData.rules.profit_target.current_state) >= 0
        ) {
          setTargetStatus("stable");
        } else {
          setTargetStatus("danger");
        }

        if (rulesData.rules.max_drawdown_limit.violated) {
          setTotalDrawdownStatus("failed");
        } else {
          setTotalDrawdownStatus("stable");
        }

        if (rulesData.rules.daily_drawdown_limit.violated) {
          setDailyDrawdownStatus("failed");
        } else {
          setDailyDrawdownStatus("stable");
        }

        if (rulesData.rules.trade_drawdown_limit.violated) {
          setTradeDrawdownStatus("failed");
        } else {
          setTradeDrawdownStatus("stable");
        }

        if (
          Number(rulesData.trading_days) >= Number(rulesData.min_trading_days)
        ) {
          setMinTradingDaysStatus("passed");
        } else {
          setMinTradingDaysStatus("danger");
        }
        if (rulesData.rules.consistency_rule.violated) {
          setConsRuleStatus("danger");
        } else {
          setConsRuleStatus("stable");
        }
        if (rulesData.rules.fast_scalp.violated) {
          setScalpProfitStatus("danger");
        } else {
          setScalpProfitStatus("stable");
        }
      } else {
        if (
          Number(rulesData.rules.profit_target.current_state) >=
          Number(rulesData.rules.profit_target.definition)
        ) {
          setTargetStatus("passed");
        } else {
          setTargetStatus("failed");
        }

        if (rulesData.rules.max_drawdown_limit.violated) {
          setTotalDrawdownStatus("failed");
        } else {
          setTotalDrawdownStatus("stable");
        }

        if (rulesData.rules.daily_drawdown_limit.violated) {
          setDailyDrawdownStatus("failed");
        } else {
          setDailyDrawdownStatus("stable");
        }

        if (rulesData.rules.trade_drawdown_limit.violated) {
          setTradeDrawdownStatus("failed");
        } else {
          setTradeDrawdownStatus("stable");
        }

        if (
          Number(rulesData.trading_days) >= Number(rulesData.min_trading_days)
        ) {
          setMinTradingDaysStatus("passed");
        } else {
          setMinTradingDaysStatus("failed");
        }
        if (rulesData.rules.consistency_rule.violated) {
          setConsRuleStatus("failed");
        } else {
          setConsRuleStatus("passed");
        }
        if (rulesData.rules.fast_scalp.violated) {
          setScalpProfitStatus("failed");
        } else {
          setScalpProfitStatus("passed");
        }
      }
    }
  }, [rulesData]);

  const missionStatuses = {
    target: targetStatus,
    totalDrawdown: totalDrawdownStatus,
    dailyDrawdown: dailyDrawdownStatus,
    tradeDrawdown: tradeDrawdownStatus,
    minTradingDays: minTradingDaysStatus,
    consistencyRule: consRuleStatus,
    scalpProfit: scalpProfitStatus,
  };

  return (
    <div className="w-full h-fit flex flex-col p-5 gap-4 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark overflow-hidden min-h-0">
      <div className="w-full flex justify-between items-center">
        <h2 className="flex gap-2.5 items-center">
          <SVG
            name="mission"
            classname="size-5 stroke-zi-blue-dark dark:stroke-white"
          />
          <span className="text-lg font-medium text-zi-text-light dark:text-zi-text-dark">
            مأموریت‌های چالش
          </span>
        </h2>

        <Custom
          onClick={() => navigate("/rule/challenge")}
          text="قوانین چالش‌ها"
          href=""
          className="bg-transparent !px-2.5 !py-1.5 mb:!px-5 mb:!py-2 !rounded-lg mb:!rounded-lg text-zi-text-light dark:text-zi-text-dark border border-zi-border-dark dark:border-zi-border-light/50 hocus:ring-1 hocus:ring-inset hocus:ring-zi-border-dark hocus:dark:ring-zi-border-light/50 text-xs mb:text-sm"
        />
      </div>

      {activeFilter[0] && (
        <MissionsGrid
          rulesData={rulesData}
          accountData={accountData}
          ruleLoading={ruleLoading}
          missionStatuses={missionStatuses}
        />
      )}
      {activeFilter[1] && (
        <MissionsTable
          rulesData={rulesData}
          accountData={accountData}
          ruleLoading={ruleLoading}
          missionStatuses={missionStatuses}
        />
      )}
    </div>
  );
}
